import PropTypes from "prop-types";
import React from "react";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

function Cost({ cost, currency, showYearly, className }) {
  const formattedCost = costToFrench(cost);
  const [integer = "0", decimal = "00"] = formattedCost
    ?.toString()
    ?.split(",") || ["-"];
  const yearlyCost = costToFrench(cost * 12);

  return (
    <div className={`acoris-cost ${className || ""}`}>
      <div className="acoris-cost__main">
        <span className="acoris-cost__main--price">
          {`${integer},${decimal} ${CURRENCY_SYMBOL[currency] || ""}`}
        </span>
        <div className="acoris-cost__main--period">ttc/mois</div>
      </div>
      {showYearly && (
        <div className="acoris-cost__secondary">
          <span className="acoris-cost__secondary--price">{yearlyCost}</span>
          <span className="acoris-cost__secondary--currency">{` ${
            CURRENCY_SYMBOL[currency] || ""
          } `}</span>
          / an
        </div>
      )}
    </div>
  );
}

Cost.propTypes = {
  cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  currency: PropTypes.string.isRequired,
  showYearly: PropTypes.bool,
  className: PropTypes.string,
};

Cost.defaultProps = {
  showYearly: false,
  className: "",
};

export default React.memo(Cost);
